import { Link } from 'wouter';
import { useLanguage } from '@/contexts/LanguageContext';

const LOGO_URL = '/manus-storage/logo-3d-optimized_a3d87dcf.webp';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer style={{
      borderTop: '1px solid oklch(1 0 0 / 6%)',
      padding: '48px 0 32px',
      background: 'oklch(0.06 0.015 260)',
    }}>
      <div className="container">
        <div className="footer-top">
          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              <img
                src={LOGO_URL}
                alt="Northgate Web Logo"
                style={{
                  width: 32, height: 32,
                  objectFit: 'contain',
                  filter: 'drop-shadow(0 0 6px rgba(37,99,235,0.6)) drop-shadow(0 0 12px rgba(6,182,212,0.3))',
                }}
              />
              <span style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, color: 'white', fontSize: '0.95rem' }}>
                Northgate Web
              </span>
            </div>
            <p style={{ fontSize: '0.85rem', color: 'oklch(0.65 0.01 260)', margin: '0 0 6px', maxWidth: 280 }}>
              {t('footer_tagline')}
            </p>
            <p style={{ fontSize: '0.78rem', color: 'oklch(0.60 0.01 260)', margin: 0 }}>
              {t('footer_legal')}
            </p>
          </div>

          {/* Navigation Links */}
          <div className="footer-links">
            <Link href="/services">{t('nav_services')}</Link>
            <Link href="/work">{t('nav_work')}</Link>
            <Link href="/pricing">{t('nav_pricing')}</Link>
            <Link href="/faq">{t('nav_faq')}</Link>
            <Link href="/contact">{t('nav_contact')}</Link>
            {/* Social Media Icons */}
            <a
              href="https://www.instagram.com/north_gateweb?igsh=MW45OXJ0ZTd5d2dzdA=="
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
                borderRadius: '4px',
                background: 'transparent',
                textDecoration: 'none',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.transform = 'scale(1.15)';
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.transform = 'scale(1)';
              }}
              title="Follow us on Instagram"
            >
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" style={{ color: 'oklch(0.65 0.01 260)' }}>
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.266.069 1.646.069 4.85 0 3.204-.012 3.584-.07 4.85-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.322a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z"/>
              </svg>
            </a>
            <a
              href="https://www.facebook.com/share/1DFqMieD1D/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
                borderRadius: '4px',
                background: 'transparent',
                textDecoration: 'none',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.transform = 'scale(1.15)';
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.transform = 'scale(1)';
              }}
              title="Follow us on Facebook"
            >
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" style={{ color: 'oklch(0.65 0.01 260)' }}>
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
          </div>

          {/* Legal Links — required on every page (DSGVO/GDPR) */}
          <div className="footer-links" style={{ borderTop: '1px solid oklch(1 0 0 / 5%)', paddingTop: 12 }}>
            <Link href="/impressum" style={{ fontSize: '0.8rem', color: 'oklch(0.62 0.01 260)' }}>{t('nav_impressum')}</Link>
            <Link href="/datenschutz" style={{ fontSize: '0.8rem', color: 'oklch(0.62 0.01 260)' }}>{t('footer_privacy')}</Link>
            <Link href="/agb" style={{ fontSize: '0.8rem', color: 'oklch(0.62 0.01 260)' }}>{t('footer_agb')}</Link>
            <Link href="/widerruf" style={{ fontSize: '0.8rem', color: 'oklch(0.62 0.01 260)' }}>{t('footer_widerruf')}</Link>
            <Link href="/widerrufsbutton" style={{ fontSize: '0.8rem', color: 'oklch(0.62 0.01 260)' }}>{t('footer_withdraw_btn')}</Link>
            <Link href="/cookies" style={{ fontSize: '0.8rem', color: 'oklch(0.62 0.01 260)' }}>{t('footer_cookies')}</Link>
            <Link href="/service-agreement" style={{ fontSize: '0.8rem', color: 'oklch(0.62 0.01 260)' }}>{t('footer_service_agreement')}</Link>

          </div>
        </div>

        <p style={{ fontSize: '0.78rem', color: 'oklch(0.58 0.01 260)', margin: 0, textAlign: 'center' }}>
          {t('footer_copy')}
        </p>
      </div>
    </footer>
  );
}
